import React from 'react';
import { useChartContext } from "@Local/Dashboard/Components/ChartContext";
import { filterTargetTypeMap } from "@Local/Dashboard/staticData";
import _ from "lodash";
import { Box, Button, Chip, Icons } from '@curves/ui-base';


const ClubSelectBox = (props) => {
    const {
        sourceData
    } = props;
    const {
        getDialog,
        selectedFilter,
        setSelectedFilter,
        setSourceData,
    } = useChartContext();
    const singleClub = _.filter(selectedFilter, { targetType: filterTargetTypeMap.singleClub });
    const clubTags = _.filter(selectedFilter, { targetType: filterTargetTypeMap.clubTag });
    const doConfirmClub = (selected) => {
        let nextSelected = _.cloneDeep(selectedFilter);
        _.remove(nextSelected, item => {
            return item.targetType === filterTargetTypeMap.singleClub || item.targetType === filterTargetTypeMap.clubTag;
        });
        setSelectedFilter(_.concat(nextSelected, selected));
        setSourceData(null);
    };
    const doRefresh = () => {
    };
    const handleSelectClub = () => {
        const dialog = getDialog();
        const { clubTagGroupOptions, clubOption } = sourceData;
        dialog.openAdvancedChartFilterClubDialog(
            { clubTagGroupOptions, clubOption },
            doRefresh, selectedFilter, doConfirmClub
        );
    };
    return (
        <Box onClick={handleSelectClub}>
            {_.size(singleClub) > 0 && (
                <Box className="text-primary">
                    {singleClub.map(item => {
                        return <div key={item.targetID}>{`指定店舖: ${item.targetName}`}</div>
                    })}
                    <Box className={'text-right cursor-pointer'}>
                        <Icons.Edit color={"primary"} fontSize={'small'} />
                    </Box>
                </Box>
            )}
            {_.size(clubTags) > 0 && (
                <Box className="tag-selector-box">
                    {clubTags && clubTags.map((tag) => {
                        return <Chip key={tag.targetID} label={tag.targetName} color={'primary'} />
                    })}
                    <Box className={'text-right cursor-pointer'}>
                        <Icons.Edit color={"primary"} fontSize={'small'} />
                    </Box>
                </Box>
            )}
            {_.size(singleClub) === 0 && _.size(clubTags) === 0 && (
                <Button color="primary"><Icons.Plus color={"primary"} /> 選擇店舖</Button>
            )}
        </Box>
    );
};
export default ClubSelectBox; 